import { render, staticRenderFns } from "./templateEmailConfirm.vue?vue&type=template&id=5ae59cb8&scoped=true"
import script from "./templateEmailConfirm.vue?vue&type=script&lang=js"
export * from "./templateEmailConfirm.vue?vue&type=script&lang=js"
import style0 from "./templateEmailConfirm.vue?vue&type=style&index=0&id=5ae59cb8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae59cb8",
  null
  
)

export default component.exports